var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "c-sidesheet",
    {
      attrs: {
        id: "table_settings_sidesheet",
        active: _vm.isOpen,
        title: _vm.title,
      },
      on: { close: _vm.close },
    },
    [
      _c("div", { staticClass: "m-table-settings" }, [
        _c("div", { staticClass: "m-table-settings__inputs" }, [
          _c(
            "div",
            { staticClass: "m-table-settings__input" },
            [
              _c("c-input", {
                staticClass: "m-table-settings__input-search",
                attrs: {
                  placeholder: "Поиск по столбцам",
                  icon: "search",
                  "placeholder-style": "italic",
                  clearable: "",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "m-table-settings__content" },
          [
            _c(
              "shadow-scroll-container",
              { staticClass: "m-table-settings__scroll" },
              [
                _c("columns-form", {
                  staticClass: "m-table-settings__results",
                  attrs: { columns: _vm.columns, filter: _vm.search },
                  model: {
                    value: _vm.selected,
                    callback: function ($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected",
                  },
                }),
                _vm.selected.length == 0
                  ? _c("error-feedback", {
                      staticClass: "m-table-settings__empty",
                      attrs: { text: "Нужно выбрать хотя бы один столбец" },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "m-table-settings__actions" },
                  [
                    _c("c-button", {
                      staticClass: "m-table-settings__actions-item",
                      attrs: { size: "large", label: "Отменить" },
                      on: { click: _vm.reset },
                    }),
                    _c("c-button", {
                      staticClass: "m-table-settings__actions-item",
                      attrs: {
                        disabled: _vm.selected.length == 0,
                        label: "Применить",
                        color: "blue",
                        size: "large",
                      },
                      on: { click: _vm.apply },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }